import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import mobileBridge from '../../helpers/MobileBridge';
import SessionManager from '../../helpers/session/SessionManager';

/**
 * This class serves as the login entry point for mobile.
 * It should only be rendered on initial login. 
 */
export class MobileEntryWrapper extends React.Component {

  componentDidMount() {
    mobileBridge.initialize(this.props.history);
    if (this.props.currentUser) {
      SessionManager.showIntroOverlays(this.props.currentUser)
        .then(() => {
          mobileBridge.login(localStorage.token, localStorage.current_company_id);
        });
    }
    else {
      this.props.history.replace('/login');
    }
  }

  render() {
    return (
      <div className="mobile-wrapper">
        <div className="content-wrapper">
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    needsLogin: state.main.needsLogin,
  };
};
export default withRouter(connect(mapStateToProps)(MobileEntryWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/MobileEntryWrapper/index.js